// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { UIModelBaseElement } from './UIModelBaseElement';
import { EnumViewType } from '../../../../../com/MetaPattern/MDA/MD/UIModel/EnumViewType';
import { UIModelComponent } from './UIModelComponent';
import { PageView } from './PageView';
import { ViewObject } from './ViewObject';
import { UIButton } from './UIButton';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
/**
 * 视图 实体类
 * 视图，由控件组成的完整逻辑前端页面单元
 */
export class UIView extends UIModelBaseElement {
  /** 绑定标志 : 绑定元素的标志，使用设计期ID，用于区分自动生成情况下的来源 */
  private _bindingCode: string;

  /** 设置：绑定标志 */
  public get bindingCode() {
    return this._bindingCode;
  }

  /** 获取：绑定标志 */
  public set bindingCode(value: string) {
    this._bindingCode = value;
  }

  /** 视图类型 : 自动生成的管理页面视图类型 */
  private _viewType: EnumViewType;

  /** 设置：视图类型 */
  public get viewType() {
    return this._viewType;
  }

  /** 获取：视图类型 */
  public set viewType(value: EnumViewType) {
    this._viewType = value;
  }

  /** 组件 的ID */
  private _component_ID: string;

  /** 获取：组件 的ID */
  public get component_ID() {
    return this._component_ID;
  }

  /** 设置：组件 的ID */
  public set component_ID(value: string) {
    this._component_ID = value;
  }

  /** 组件  */
  private _component: UIModelComponent;

  /** 获取：组件  */
  public get component() {
    return this._component;
  }

  /** 设置：组件  */
  public set component(value: UIModelComponent) {
    this._component = value;
    if (value !== null) {
      this.component_ID = value.id;
    } else {
      this.component_ID = '';
    }
  }

  /** 页面视图 */
  private _pageViews: Array<PageView>;

  /** 获取：页面视图 */
  public get pageViews() {
    return this._pageViews;
  }

  /** 设置：页面视图 */
  public set pageViews(value: Array<PageView>) {
    this._pageViews = value;
  }

  /** 上级视图 的ID */
  private _parent_ID: string;

  /** 获取：上级视图 的ID */
  public get parent_ID() {
    return this._parent_ID;
  }

  /** 设置：上级视图 的ID */
  public set parent_ID(value: string) {
    this._parent_ID = value;
  }

  /** 上级视图  */
  private _parent: UIView;

  /** 获取：上级视图  */
  public get parent() {
    return this._parent;
  }

  /** 设置：上级视图  */
  public set parent(value: UIView) {
    this._parent = value;
    if (value !== null) {
      this.parent_ID = value.id;
    } else {
      this.parent_ID = '';
    }
  }

  /** 子视图 */
  private _children: Array<UIView>;

  /** 获取：子视图 */
  public get children() {
    return this._children;
  }

  /** 设置：子视图 */
  public set children(value: Array<UIView>) {
    this._children = value;
  }

  /** 视图对象 的ID */
  private _viewObject_ID: string;

  /** 获取：视图对象 的ID */
  public get viewObject_ID() {
    return this._viewObject_ID;
  }

  /** 设置：视图对象 的ID */
  public set viewObject_ID(value: string) {
    this._viewObject_ID = value;
  }

  /** 视图对象  */
  private _viewObject: ViewObject;

  /** 获取：视图对象  */
  public get viewObject() {
    return this._viewObject;
  }

  /** 设置：视图对象  */
  public set viewObject(value: ViewObject) {
    this._viewObject = value;
    if (value !== null) {
      this.viewObject_ID = value.id;
    } else {
      this.viewObject_ID = '';
    }
  }

  /** 按钮 */
  private _buttons: Array<UIButton>;

  /** 获取：按钮 */
  public get buttons() {
    return this._buttons;
  }

  /** 设置：按钮 */
  public set buttons(value: Array<UIButton>) {
    this._buttons = value;
  }

  constructor() {
    super();
    this._bindingCode = '';
    this._viewType = EnumViewType.Custom;
    this._component_ID = '';
    this._component = null;
    this._pageViews = new Array<PageView>();
    this._parent_ID = '';
    this._parent = null;
    this._children = new Array<UIView>();
    this._viewObject_ID = '';
    this._viewObject = null;
    this._buttons = new Array<UIButton>();
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: UIView, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.bindingCode = element.bindingCode;
      this.viewType = element.viewType;
      this.component_ID = element.component_ID;
      if (hasReference && element.component !== null) {
        this.component = element.component;
      }
      this.parent_ID = element.parent_ID;
      if (hasReference && element.parent !== null) {
        this.parent = element.parent;
      }
      this.viewObject_ID = element.viewObject_ID;
      if (hasReference && element.viewObject !== null) {
        this.viewObject = element.viewObject;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.bindingCode = json.BindingCode;
    this.viewType = json.ViewType as EnumViewType;
    this.component_ID = json.Component_ID;
    // if (json.Component !== null) {
    //   this.component = UIModelComponent.Create(json.Component);
    // }
    if (json.PageViews && json.PageViews.length > 0) {
      json.PageViews.forEach((element: any) => {
        const pageView = PageView.Create(element);
        // pageView.view = this;
        this.pageViews.push(pageView);
      });
    }
    this.parent_ID = json.Parent_ID;
    // if (json.Parent !== null) {
    //   this.parent = UIView.Create(json.Parent);
    // }
    if (json.Children && json.Children.length > 0) {
      json.Children.forEach((element: any) => {
        const uIView = UIView.Create(element);
        // uIView.parent = this;
        this.children.push(uIView);
      });
    }
    this.viewObject_ID = json.ViewObject_ID;
    // if (json.ViewObject !== null) {
    //   this.viewObject = ViewObject.Create(json.ViewObject);
    // }
    if (json.Buttons && json.Buttons.length > 0) {
      json.Buttons.forEach((element: any) => {
        const uIButton = UIButton.Create(element);
        // uIButton.view = this;
        this.buttons.push(uIButton);
      });
    }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.BindingCode = this.bindingCode;
    json.ViewType = this.viewType;
    json.Component_ID = this.component_ID;
    if (this.pageViews && this.pageViews.length > 0) {
      json.PageViews = [];
      this.pageViews.forEach((element) => {
        json.PageViews.push(element.toJson());
      });
    }
    json.Parent_ID = this.parent_ID;
    if (this.children && this.children.length > 0) {
      json.Children = [];
      this.children.forEach((element) => {
        json.Children.push(element.toJson());
      });
    }
    json.ViewObject_ID = this.viewObject_ID;
    if (this.buttons && this.buttons.length > 0) {
      json.Buttons = [];
      this.buttons.forEach((element) => {
        json.Buttons.push(element.toJson());
      });
    }
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    return context;
  }

  static Create(json: any): UIView {
    const uIView = new UIView();
    uIView.Deserialize(json);
    uIView.json = json;
    return uIView;
  }
}
